// extracted by css-extract-rspack-plugin
export default {"closeButton":"_db3a63c9","container":"_505d13ee","isDraggable":"_5c70a0ce"};